import React, { useEffect, useState } from "react";
import "../Styles/blog.scss";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../components/loader/Loader";

function Blogs(props) {
  const [blogdata, setdata] = useState([]);
  const [loader, setLoader] = useState(true);
  const fetchData = async () => {
    const url = props.toggle
      ? "https://backend.sambhajipatilnilangekar.com/api/blog/getBlogByCategory?category=Marathi"
      : "https://backend.sambhajipatilnilangekar.com/api/blog/getBlogByCategory?category=English";

    try {
      setLoader(true);
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      setdata(response.data.response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [props.toggle]);

  return (
    <>
      {loader ? (
        <Loader />
      ) : (
        props?.data &&
        props?.data?.map((item, index) => {
          return (
            <div className="blog-parent parent" key={index}>
              <div className="blog-container cont">
                <div className="blog-headding">
                  <h2>{item.Header_Blog}</h2>
                </div>
                {blogdata &&
                  blogdata
                    ?.slice()
                    ?.reverse()
                    .map((blog) => {
                      return (
                        <Link to={`/blogs/${blog.id}`} className="blog-card">
                          <div className="blog-card-img ">
                            <img
                              src={`https://physicalserverimages.pandozasolutions.com/images/spn_images/${blog?.image}`}
                              alt="blog-img"
                              className="bg-img-cover blog-img"
                            />
                            <h4 className="blogdate">{blog.date}</h4>
                          </div>

                          <div className="blog-card-bottom">
                            <h3 className="blog-title">
                              {blog.title?.slice(0, 30)} ...
                            </h3>
                            {/* <Link to={`/blogs/${data.id}`} className='btn'>Read More</Link> */}
                            {/* <div className="blog-text"></div> */}
                          </div>
                        </Link>
                      );
                    })}
              </div>
            </div>
          );
        })
      )}
    </>
  );
}

export default Blogs;
